import React, { Component } from "react";
import ReactEcharts from "echarts-for-react";

class Pie extends Component {
  getOption = () => {
    const { labels, data, colors, title } = this.props;

    return {
      toolbox: {
        show: false,
      },
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b} : {c} ({d}%)",
      },
      legend: {
        orient: "vertical",
        left: "left",
        data: labels,
      },
      color: colors,
      series: [
        {
          name: title || "Data",
          type: "pie",
          radius: "55%",
          center: ["70%", "40%"],
          data: data.map((item, index) => ({
            value: item,
            name: labels[index],
          })),
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };
  };

  render() {
    return (
      <React.Fragment>
        <ReactEcharts style={{ height: "200px" }} option={this.getOption()} />
      </React.Fragment>
    );
  }
}

export default Pie;
